import { createAction } from '@reduxjs/toolkit';

export const setAccountId = createAction<string>('credentials/setAccountId');

export const setAuthToken = createAction<string>('credentials/setAuthToken');

export const setAccessToken = createAction<string>(
    'credentials/setAccessToken'
);

//export const setUserRoles = createAction<Array<string>>(
//    'credentials/setUserRoles'
//);
